// In Next.js, this file would be called: app/providers.jsx

'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { makeQueryClient } from '@/queries/options';

let browserQueryClient: QueryClient | undefined;

export function getQueryClient() {
  if (typeof window === 'undefined') {
    // Server: always make a new query client
    return makeQueryClient();
  }
  // BROWSER: 기존 query client가 없는 경우 새로운 client를 생성합니다
  // React가 초기 렌더링 중에 일시 중단(suspend)될 때
  // 새로운 client를 다시 생성하지 않도록 하는 것이 매우 중요합니다.
  // query client 생성 이후에 suspense boundary가 있다면 이 작업이 필요하지 않을 수 있습니다.
  if (!browserQueryClient) {
    browserQueryClient = makeQueryClient();
  }
  return browserQueryClient;
}

export default function Providers({ children }: { children: React.ReactNode }) {
  // NOTE: suspense boundary가 없는 상태에서 query client를 초기화할 때는 useState를 사용하지 마세요.
  //       React가 초기 렌더링 중에 일시 중단되면 boundary가 없을 경우 client를 버리게 됩니다.
  const queryClient = getQueryClient();

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
